import { render, staticRenderFns } from "./CarryForward.vue?vue&type=template&id=a10ae97c&scoped=true"
import script from "./CarryForward.vue?vue&type=script&lang=js"
export * from "./CarryForward.vue?vue&type=script&lang=js"
import style0 from "./CarryForward.vue?vue&type=style&index=0&id=a10ae97c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10ae97c",
  null
  
)

export default component.exports